
const sideTypes = [

  { id: 'Buy', value: 'Buy' },
  { id: 'Sell', value: 'Sell' },
  { id: 'Sell Short', value: 'Sell Short' }
];

const filterTimePattern = 'HH:mm:ss.SSS';
const filterDatePattern = 'MM/dd/yyyy';

const capacityTypes = [
  { id: 'Agency', value: 'Agency' },
  { id: 'Principal', value: 'Principal' }

];

const orderStatusTypes = [

  { id: 'Open', value: 'Open' },
  { id: 'Rejected', value: 'Rejected' },
  { id: 'Canceled', value: 'Canceled' },
  { id: 'Filled', value: 'Filled' },
  { id: 'Expired', value: 'Expired' },
  { id: 'Pending', value: 'Pending' },
  { id: 'Pending Cancel', value: 'Pending Cancel' },
  { id: 'Pending Replace', value: 'Pending Replace' },
  { id: 'Pending Expire', value: 'Pending Expire' },
  { id: 'Pending Reject', value: 'Pending Reject' }

];

const categoryTypes = [
  { id: 1000, value: 'OTCX' },
  { id: 6209, value: 'Link ATS' },
  { id: 7094, value: 'ARCA' },
  { id: 7168, value: 'CICF' },
  { id: 7166, value: 'IDQS' },
  { id: 6, value: 'ROUT' },
  { id: 8, value: 'CROSS' }
];

const tifTypes = [
  { id: 'DAY', value: 'DAY' },
  { id: 'GTX', value: 'GTX' },
  { id: 'IOC', value: 'IOC' },
  { id: 'GTT', value: 'GTT' },
  { id: 'GTC', value: 'GTC' },
  { id: 'FOK', value: 'FOK' },
  { id: 'OC', value: 'OC' }
];

// IDQS
const idqsCategoryTypes = [
  { id: 1001, value: 'IDQS' },
  { id: 6209, value: 'Link ATS' },
  { id: 7094, value: 'ARCA' },
  { id: 7168, value: 'CICF' },
  { id: 7167, value: 'OTCX' },
  { id: 6, value: 'ROUT' },
  { id: 8, value: 'CROSS' }
];

const IDQS_ORDER_CATEGORY = [6, 8, 1001, 6209, 7094, 7168, 7167];

// NMS

const nmsCategoryTypes = [
  { id: 1001, value: 'MOON' },
  { id: 7272, value: 'Blue Ocean' },
  { id: 6209, value: 'Link ATS' },
  { id: 7094, value: 'ARCA' },
  { id: 7168, value: 'CICF' },
  { id: 7167, value: 'OTCX' },
  { id: 6, value: 'ROUT' },
  { id: 8, value: 'CROSS' }
];

const NMS_ORDER_CATEGORY = [6, 8, 7272, 1001, 6209, 7094, 7168, 7167];

export { categoryTypes, idqsCategoryTypes, nmsCategoryTypes, NMS_ORDER_CATEGORY, IDQS_ORDER_CATEGORY, sideTypes, orderStatusTypes, capacityTypes, tifTypes, filterDatePattern, filterTimePattern };
